export default {
  "salesGroup.name": "取引部門名",
  "salesGroup.code": "取引部門コード",
  "salesGroup.assignSubjects": "勘定科目",
  "salesGroup.firstGrant": "第一補助",
  "salesGroup.secondGrant": "第二補助",
  "salesGroup.assignSubjectsOrigin": "勘定科目（原価）",
  "salesGroup.firstGrantOrigin": "第一補助（原価）",
  "salesGroup.secondGrantOrigin": "第二補助（原価）",

  "salesGroup.dialog.title": "取引部門作成・編集",
  "salesGroup.dialog.basicInfo": "取引部門基本情報",
  "salesGroup.dialog.assignSubjects": "勘定科目（仕訳連携用）",
  "salesGroup.dialog.subject1InputMethod": "補助科目1入力方式",
  "salesGroup.dialog.subject1": "補助科目1（仕訳連携用）",
  "salesGroup.dialog.subject2InputMethod": "補助科目2入力方式",
  "salesGroup.dialog.subject2": "補助科目2（仕訳連携用）",
  "salesGroup.dialog.assignSubjectsOrigin": "勘定科目（原価）（仕訳連携用）",
  "salesGroup.dialog.subject1InputMethodOrigin": "補助科目1（原価）入力方式",
  "salesGroup.dialog.subjectOrigin1": "補助科目1（原価）（仕訳連携用）",
  "salesGroup.dialog.subject2InputMethodOrigin": "補助科目2（原価）入力方式",
  "salesGroup.dialog.subjectOrigin2": "補助科目2（原価）（仕訳連携用）",
  "salesGroup.dialog.freeEntry": "自由入力",
  "salesGroup.dialog.subjectSelection": "補助科目分類を選択",

  "salesGroup.dialog.selectList.client1": "取引先1を利用",
  "salesGroup.dialog.selectList.client2": "取引先2を利用",
  "salesGroup.dialog.selectList.client3": "取引先3を利用",
  "salesGroup.dialog.selectList.clientGroup1": "取引先区分1を利用",
  "salesGroup.dialog.selectList.clientGroup2": "取引先区分2を利用",
  "salesGroup.dialog.selectList.clientGroup3": "取引先区分3を利用",
  "salesGroup.dialog.selectList.cinema1": "劇場1を利用",
  "salesGroup.dialog.selectList.cinema2": "劇場2を利用",
  "salesGroup.dialog.selectList.cinema3": "劇場3を利用",
};